import { AppBar, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {
    return (
        <AppBar position="static" color="transparent" elevation={1}>
            <Toolbar sx={{ justifyContent: 'space-between', paddingX: { xs: 2, md: 4 } }}>
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    Ethio Future Tutor
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default Header;